import { createFileRoute, redirect } from '@tanstack/react-router';

import { isPersonAdmin } from 'helpers/query';

/** Legacy `/users/:userId/settings` → `/users/:userId` (admins) or `/profile` (members). */
export const Route = createFileRoute(
  '/_private/_route/users/$userId/settings/',
)({
  beforeLoad: ({ context, params }) => {
    if (isPersonAdmin(context.user)) {
      throw redirect({
        params: { userId: params.userId },
        replace: true,
        to: '/users/$userId',
      });
    }

    throw redirect({ replace: true, to: '/profile' });
  },
});
